document.addEventListener('click', function(e) {
  const button = e.target.closest('[data-menu]');
  if (!button) return;
  const nav = document.querySelector('#mobile-nav');
  nav.classList.toggle('open');
  button.setAttribute('aria-expanded', String(nav.classList.contains('open')));
});
const variant = document.querySelector('#derby-variant');
if (variant) {
  variant.addEventListener('change', function() {
    const chosen = this.selectedOptions[0];
    const price = document.querySelector('#derby-price');
    if (price && chosen) price.textContent = chosen.dataset.price;
  });
}
